// extracted by mini-css-extract-plugin
export var typingIndicator = "_o3-0";